import { h, Component } from 'preact';
import { condClass } from 'utils/utils';
import s from 'components/shared/simpleVideoPlayer/canvasVideoPlayer.sss';


const now = (typeof window !== 'undefined' && window.performance && performance.now) ? performance.now : Date.now;


/**
 * Canvas hack (mostly used on ios) for a playing a video inline
 */
export default class CanvasVideoPlayer extends Component {

	/**
	 * LIFECYCLE METHODS
	 */

	componentDidMount() {
		if (!this.$video) return;
		// this.$cnvs.width = this.$video.offsetWidth;
		// this.$cnvs.height = this.$video.offsetHeight;
		// this.ctx = this.$cnvs.getContext('2d');
		// this.lastTime = now();
		if (this.$video.readyState >= 1) {
			this.loadedMetaData();
		} else {
			this.$video.addEventListener('loadedmetadata', this.loadedMetaData);
			// this.$video.load();
		}
	}

	componentWillUnmount() {
		this.disabled = true;
	}

	loadedMetaData = () => {
		if (!this.started) {
			this.$cnvs.width = this.$video.offsetWidth;
			this.$cnvs.height = this.$video.offsetHeight;
			this.ctx = this.$cnvs.getContext('2d');
			this.lastTime = now();
			this.duration = this.$video.duration;
			requestAnimationFrame(this.rafPlayInlineVideo);
			this.started = true;
		}
	};

	rafPlayInlineVideo = () => {
		if (this.$video) {
			const time = now() - this.lastTime;
			// const timeCode = Math.round(time / 25) / 1000 * 25;
			const timeCode = time / 1000;

			this.$video.currentTime = timeCode;
			if (this.duration < timeCode) {
				this.lastTime = now();
			}

			const width = this.$cnvs.width;
			const height = this.$cnvs.height;

			this.ctx.drawImage(this.$video, 0, 0, width, height);
		}

		if (!this.disabled) {
			requestAnimationFrame(this.rafPlayInlineVideo);
		}
	};

	render() {
		return (
			<div class={s.container}>
				<canvas ref={$ref => this.$cnvs = $ref} class={s.cnvs} />
				<video preload="none" src={this.props.src} class={s.video + condClass(this.props.class)} ref={$ref => this.$video = $ref} preload />
			</div>
		);
	}

}
